/**
 * Builds the destination path for a notification click.
 * List pages that support a view modal get both a list filter and `share-link`
 * so the matching record is filtered and its details modal auto-opens.
 */
export const getNotificationTargetPath = (
  item: {
    entityType?: string | null
    entityId?: string | null
    description?: string | null
  },
  currentSearch = ''
): string | null => {
  const id = item.entityId
  if (!id) return null

  switch (item.entityType) {
    case 'policy':
      return `/policy?policyId=${id}&share-link=${id}`
    case 'dashboard':
      return id === 'POLICY' ? '/policy-dashboard' : null
    case 'credentialRegistry':
      return `/settings/credential-registry?share-link=${id}`
    case 'changeManagementProcess':
      return `/change-management-process?changeManagementProcessId=${id}&share-link=${id}`
    case 'meetingMinute':
      return `/meeting-minutes?meetingMinutesId=${id}&share-link=${id}`
    case 'exemptionsRegister':
      return `/exemptions-register?exemptionId=${id}&share-link=${id}`
    case 'incomingQuestionnaire':
      return `/service-provider-incoming-questionnaire/${id}/answer`
    case 'serviceProvider':
      return `/service-provider-list?share-link=${id}`
    case 'serviceProviderAssessment':
      return `/service-provider-assessment?share-link=${id}`
    case 'ctraEngagement':
      return `/ctra/engagements/${id}?tab=statement-of-applicability`
    case 'task': {
      const projectId = (item.description ?? '').match(/\[project id:\s*([^\]]+)\]/i)?.[1]?.trim()
      if (!projectId) return null
      const currentParams = new URLSearchParams(currentSearch)
      const samePciProject =
        currentParams.get('isPciDssProject') === 'true' && currentParams.get('projectId') === projectId
      const pciQuery = samePciProject ? '&isPciDssProject=true' : ''
      return `/manage-projects/tasks?projectId=${projectId}&tab=board&share-link=${id}${pciQuery}`
    }
    case 'audit': {
      const desc = item.description ?? ''
      const organisationStandardId = desc.match(/\[standard id:\s*([^,\]]+)/i)?.[1]?.trim()
      const controlId = desc.match(/control id:\s*([^,\]]+)/i)?.[1]?.trim()
      const forType = desc.match(/for:\s*([^\]]+)\]/i)?.[1]?.trim()
      const baseRoute = forType === 'assessment' ? '/assessments' : forType === 'audit-list' ? '/audit-list' : '/audit'
      if (!organisationStandardId) return null
      return controlId
        ? `${baseRoute}/${organisationStandardId}?controlId=${controlId}`
        : `${baseRoute}/${organisationStandardId}`
    }
    default:
      return null
  }
}
